import { Resource as a, API as o } from "@coveo/platform-client";
const t = class t extends a {
  /**
   * Returns a paginated list of search page interfaces for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve search page interfaces.
   * @param {ListHostedInterfacesParams} options Options to configure the request.
   * @returns {Promise<PageModel<SearchPageInterfaceConfiguration>>} Paginated list of search page interfaces for the specified project.
   */
  listSearchInterfacesByProjectId(r, i = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/interfaces`, {
        ...i,
        projectId: r
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${o.orgPlaceholder}/searchpage/v1`;
let s = t;
export {
  s as NextGenSearchPagesInternalResource
};
//# sourceMappingURL=NextGenSearchPagesInternalResource.js.map
